// Supported translation languages and short-form ISO-ish abbreviations
// used in the side pills. Keep this list in sync with backend
// `SUPPORTED_LANGUAGES` (server.py) — display strings only, no logic.

export const LANGUAGES = [
  "English", "Spanish", "French", "Italian", "German", "Portuguese",
  "Dutch", "Japanese", "Mandarin Chinese", "Cantonese", "Korean",
  "Thai", "Vietnamese", "Indonesian", "Filipino (Tagalog)", "Hindi",
  "Arabic", "Turkish", "Greek", "Polish", "Czech", "Swedish",
  "Norwegian", "Danish", "Finnish", "Hebrew", "Russian", "Ukrainian",
  "Romanian", "Hungarian",
];

export const PROVIDERS = [
  { id: "gemini", label: "Gemini 3 Flash" },
  { id: "claude", label: "Claude Sonnet 4.5" },
];

const ABBREV_MAP = {
  English: "EN",
  Spanish: "ES",
  French: "FR",
  Italian: "IT",
  German: "DE",
  Portuguese: "PT",
  Dutch: "NL",
  Japanese: "JA",
  "Mandarin Chinese": "ZH",
  Cantonese: "YUE",
  Korean: "KO",
  Thai: "TH",
  Vietnamese: "VI",
  Indonesian: "ID",
  "Filipino (Tagalog)": "TL",
  Hindi: "HI",
  Arabic: "AR",
  Turkish: "TR",
  Greek: "EL",
  Polish: "PL",
  Czech: "CS",
  Swedish: "SV",
  Norwegian: "NO",
  Danish: "DA",
  Finnish: "FI",
  Hebrew: "HE",
  Russian: "RU",
  Ukrainian: "UK",
  Romanian: "RO",
  Hungarian: "HU",
};

// Shorten language name to a 2-3 char tag for the pill (e.g. "Mandarin
// Chinese" → "ZH").
export function langAbbrev(name) {
  return ABBREV_MAP[name] || (name || "").slice(0, 2).toUpperCase();
}
